import { selectCurrentAuth } from '@auth/slices/auth';
import { useAppSelector } from '@app/hooks/index';

export const useAuth = () => useAppSelector(selectCurrentAuth);
